import React, { useState, useEffect } from "react";
import queryString from "query-string";
import PropTypes from "prop-types";
import axios from "axios";
import Moment from "react-moment";

const VipNewebpayCode = ({ location }) => {

  const [record, setRecord] = useState({});

  useEffect(() => {
    async function fetchExistingReport(orderno) {
      try {
        const result = await axios(`/api/vipv3/report_code/${orderno}`);
        //console.log("result", result.data.record);
        setRecord(result.data.record);
      } catch (error) {
        console.error(error);
      }
    }
    const search_values = queryString.parse(location.search);
    if (search_values.orderno) {
      fetchExistingReport(search_values.orderno);
    }
  }, [location.search]); 

  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-3 mt-3"> </div>
        <div className="col-lg-6 mt-3">
          {record.Status === 'SUCCESS' && (
          <div className="card border-success mb-3">
            <div className="card-header bg-success text-light">繳費資訊</div>
            <div className="card-body text-success">
              <div className="card-text">
                <table className="table table-hover">
                  <tbody>
                    <tr>
                      <th scope="row">訂單編號</th>
                      <td>{record.report_id}</td>
                    </tr>
                    <tr>
                      <th scope="row">藍新金流交易序號</th>
                      <td>{record.TradeNo}</td>
                    </tr>
                    <tr>
                      <th scope="row">購買品項</th>
                      <td>{`${record.title} (x${record.qty})`}</td>
                    </tr>
                    <tr>
                      <th scope="row">訂單金額</th>
                      <td>
                        {new Intl.NumberFormat("zh-TW", {
                          style: "currency",
                          currency: "TWD",
                        }).format(record.Amt)}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" colSpan="2">
                        <hr />
                      </th>
                    </tr>
                    <tr>
                      <th scope="row">應付金額</th>
                      <td>
                        <font color="red">
                          {new Intl.NumberFormat("zh-TW", {
                          style: "currency",
                          currency: "TWD",
                        }).format(record.Amt)}
                        </font>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" colSpan="2">
                        <hr />
                      </th>
                    </tr>
                    {record.PaymentType === "VACC" && (
                    <tr>
                      <th scope="row">銀行代碼</th>
                      <td>{record.BankCode}</td>
                    </tr>
                    )}
                    <tr>
                      <th scope="row">{record.PaymentType === "VACC" ? "轉帳帳號" : "超商繳費代碼"}</th>
                      <td>{record.CodeNo}</td>
                    </tr>
                    <tr>
                      <th scope="row">交易結果</th>
                      <td>{`${record.Message}(${record.TradeStatus})`}</td>
                    </tr>
                    <tr>
                      <th scope="row">有效繳費時間</th>
                      <td><Moment format="YYYY-MM-DD">{record.ExpireDate}</Moment> {record.ExpireTime}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="card-footer text-center">
              <small className="text-muted">
                {record.PaymentType === "VACC" ? (
                  <ui>
                    <li>請記錄您的付款資料，並於繳費期限內完成支付，逾繳費時間該轉帳帳號將失效。您可至全台任一ATM自動櫃員機或透過任何銀行之網路ATM進行交易轉帳，
                      完成轉帳後藍新金流將發送交易結果通知信至您的電子信箱。若逾繳費時間，本筆訂單將作廢，請您重新下訂。</li>
                  </ui>
                ) : (
                  <ui>
                    <li>請記錄您的付款資訊，並於繳費期限內完成支付，逾繳費時間該繳費代碼將失效。</li>
                    <li>您可至全台7-ELEVEN、全家、OK mart、萊爾富超商店內之多媒體機台(ibon、FamiPort、OK-go、Life-ET)上列印繳費單至超商櫃台以現金繳費。</li>
                    <li>四大超商繳費操作流程說明：</li>
                    <li><a href="https://www.newebpay.com/info/site_description/seven_ibon_embedded" target="_blank"><img src="/p/image/wire_report/ipon.png" /></a>
                    <a href="https://www.newebpay.com/info/site_description/family_embedded" target="_blank"><img src="/p/image/wire_report/familyport.png" /></a>
                    <a href="https://www.newebpay.com/info/site_description/okshop_embedded" target="_blank"><img src="/p/image/wire_report/okgo.png" /></a>
                    <a href="https://www.newebpay.com/info/site_description/hilife_embedded" target="_blank"><img src="/p/image/wire_report/lifeet.png" /></a></li>
                  </ui>
                )
                }
              </small>
            </div>
          </div>)}
        </div>
        <div className="col-lg-3 mt-3"> </div>
      </div>
    </div>
  );
};

VipNewebpayCode.propTypes = {
  record: PropTypes.object.isRequired,
};

export default VipNewebpayCode;
